module.exports = __webpack_public_path__ + "static/media/Group_2.1.5aa427e6.png";